import React, { useState, useEffect } from "react";
import { Tabs, Tab, Form, Row, Col } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import InventoryList from "./InventoryList";
import GroupLotList from "./GroupLotList";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import { LINEAR_GRADIENT_BG } from "../../const";
import GroupCurrencyList from "./GroupCurrencyList";
import { useTranslation } from "react-i18next";

const InventoryTabs = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("inventory");
    const [isTitle, setIsTitle] = useState(t("inv_title"));
    const [selectDate, setSelectDate] = useState("createdAt");

    // Effect to handle URL changes
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const tab = searchParams.get("tab");
        if (tab) {
        setActiveTab(tab);
        }
    }, [location]);

    // Handle tab change
    const handleTabChange = (key) => {
        setActiveTab(key);
        history.push(`/inventory/limit/50/page/1?tab=${key}`);
    };

    // Handle date toggle
    const optionsDate = [
        { value: "createdAt", label: t("inv_date") },
        { value: "mfg", label: t("inv_mfg") },
        { value: "exp", label: t("inv_exp") }
    ];

    return (
        <div className="inventory-container">
        <BreadCrumbComponent goback={history.goBack} txtSecond={t("inv_breadcrumb")} />
        
        <div style={{ padding: "0 1em" }}>
            <Row className="mb-3">
                <Col key={1} md="auto"><h5><b>{isTitle}</b></h5></Col>
                {
                    activeTab === "inventory" && (
                        <Col key={2} md="auto">
                            <Form.Select
                                value={selectDate}
                                onChange={(e) => setSelectDate(e.target.value)}
                                style={{ color: "#6B7280" }}
                            >
                                {optionsDate.map((option) => (
                                    <option key={option?.value} value={option?.value}>
                                    {option?.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                    )
                }
            </Row>
            
            <Tabs
                activeKey={activeTab}
                onSelect={handleTabChange}
                className="mb-3 inventory-tabs"
                style={{ borderBottom: "none" }}
            >
            <Tab 
                eventKey="inventory" 
                title={t("inv_tab_list")}
                tabClassName="inventory-tab"
            >
                {activeTab === "inventory" && <InventoryList setIsTitle={setIsTitle} selectDate={selectDate} />}
            </Tab>
            <Tab 
                eventKey="group-lot" 
                title={t("inv_tab_group_lot")}
                tabClassName="inventory-tab"
            >
                {activeTab === "group-lot" && <GroupLotList setIsTitle={setIsTitle} />}
            </Tab>
            <Tab 
                eventKey="group-currency" 
                title={t("inv_tab_group_currency")}
                tabClassName="inventory-tab"
            >
                {activeTab === "group-currency" && <GroupCurrencyList setIsTitle={setIsTitle} />}
            </Tab>
            </Tabs>
        </div>

        <style jsx>{`
            .inventory-tabs .nav-link {
            color: #6B7280;
            font-weight: 500;
            border: none;
            padding: 0.5rem 1rem;
            margin-right: 1rem;
            background: transparent;
            }
            .inventory-tabs .nav-link.active {
            color: #fff;
            background: ${LINEAR_GRADIENT_BG};
            border-radius: 4px;
            }
            .inventory-tab {
            transition: all 0.3s ease;
            }
        `}</style>
        </div>
    );
};

export default InventoryTabs;